/**
 * Section 2: Property Access
 */

import { useCallback } from 'preact/hooks';
import { useForm } from '@ox/visits-ui/context/FormContext';
import { Input, Select, Textarea } from '@ox/visits-ui/components/shared/FormComponents';

export function Section7Valuation() {
  const { formData, updateField } = useForm();

  const handleEstimatedValueChange = useCallback(
    (value: string) => updateField('estimated_value', value),
    [updateField],
  );

  const handleConfidenceLevelChange = useCallback(
    (value: string) => updateField('confidence_level', value),
    [updateField],
  );

  const handleValuationRationaleChange = useCallback(
    (value: string) => updateField('valuation_rationale', value),
    [updateField],
  );

  const handleMarketInsightsChange = useCallback(
    (value: string) => updateField('market_insights', value),
    [updateField],
  );

  return (
    <div className="form-section">
      <h2>Agent Valuation</h2>

      <Input
        label="Your Estimated Market Value"
        name="estimated_value"
        value={formData.estimated_value || ''}
        onChange={handleEstimatedValueChange}
        placeholder="Please specify..."
        required
      />
      <Select
        label="Confidence Level in Your Valuation"
        name="confidence_level"
        value={formData.confidence_level || ''}
        onChange={handleConfidenceLevelChange}
        options={[
          { label: 'Select...', value: '', disabled: true },
          { label: 'High', value: 'high' },
          { label: 'Medium', value: 'medium' },
          { label: 'Low', value: 'low' },
        ]}
        required
      />
      <Textarea
        label="Valuation Rationale - Why this value? What did you consider?"
        name="valuation_rationale"
        value={formData.valuation_rationale || ''}
        onChange={handleValuationRationaleChange}
        autoSize
        required
      />
      <Textarea
        label="Additional Market Insights"
        name="market_insights"
        value={formData.market_insights || ''}
        onChange={handleMarketInsightsChange}
        autoSize
      />
    </div>
  );
}
